import React from 'react'
import Headline from './headline'
import SignupForm from './signup_form'
import Thanks from './thanks'

const Content = ({requireConsent, consentError, currentView, viewOptions, formError, formEnabled, formRefs, handleSubmit, handleFormChange}) => (
  <section>
    <Headline />
    {
      currentView === viewOptions.form &&
      <SignupForm
        requireConsent={requireConsent}
        consentError={consentError}
        formEnabled={formEnabled}
        formError={formError}
        formRefs={formRefs}
        handleSubmit={handleSubmit}
        handleFormChange={handleFormChange} />
    }
    {
      currentView === viewOptions.thanks &&
      <Thanks />
    }
  </section>
)

export default Content



// WEBPACK FOOTER //
// ./src/components/homepage/content.js